import type { DocumentUploadResult } from '../types';

export async function sendDocumentBatch(
  files: File[],
  send: (file: File) => Promise<DocumentUploadResult>,
  onAccepted: (result: DocumentUploadResult) => void,
) {
  let accepted = 0;
  let confirmed = 0;
  let error = '';
  // Keep one file per POST. A failed confirmation must never resend the file.
  for (const file of files) {
    let result: DocumentUploadResult;
    try { result = await send(file); }
    catch (reason) {
      const detail = reason instanceof Error ? reason.message : 'Cererea nu a primit confirmare.';
      error = `Trimiterea fișierului „${file.name}” nu a putut fi confirmată: ${detail} Verifică lista înainte de a retrimite.`;
      break;
    }
    accepted++;
    if (result.verificationStatus === 'confirmed') confirmed++;
    onAccepted(result);
  }
  const message = accepted
    ? `API-ul a acceptat ${accepted} din ${files.length} fișiere.${confirmed < accepted ? ' Confirmarea imediată a vizibilității este incompletă. Verifică lista înainte de a retrimite fișierele.' : ' Vizibilitatea lor în listă a fost confirmată.'}`
    : '';
  return { accepted, confirmed, error, message };
}
